import React, { Component } from "react";
import Button from "./Button";
import { FormattedMessage } from "react-intl";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

import "../static/style/dashboard.css";
import "../static/style/badge.css";

import FontAwesomeIcon from "@fortawesome/react-fontawesome";

class DashCard extends Component {
  constructor(props) {
    super(props);

    this.state = {
      expanded: false
    };
  }
  render() {
    return (
      <li className="ass-car-list-element">
        <div className={`card ass-card-${this.props.border}`}>
          <div className="card-body">
            <div className={"row "}>
              <div className={"col-sm-8"}>
                <h3 className="card-title">{this.props.name}</h3>
                <h6 className="card-subtitle mb-2 ass-card-guide-s">
                  {this.props.type === "debt" ? (
                    <FormattedMessage
                      id="app.dashcard.case_no"
                      defaultMessage="Asianumero"
                    />
                  ) : (
                    <FormattedMessage
                      id="app.dashcard.invoice_no"
                      defaultMessage="Laskunumero"
                    />
                  )}
                  : {this.props.nro}
                </h6>
              </div>
              <div className={"col-sm-4 text-right align-self-center"}>
                {this.props.badge}
              </div>
            </div>
            <hr />
            <div className="row align-items-center">
              <div className="col-md-2">
                <p className="ass-card-guide">
                  {this.props.lblSum} {this.props.parts}
                </p>
                <p className="ass-card-price">{this.props.open} €</p>
              </div>
              {this.props.due ? (
                <div className="col-md-2">
                  <p className="ass-card-guide">
                    <FormattedMessage
                      id="app.dashcard.due"
                      defaultMessage="Eräpäivä"
                    />
                  </p>
                  <p className="ass-card-price">{this.props.due} </p>
                </div>
              ) : null}
              {this.props.paid ? (
                <div className="col-md-2">
                  <p className="ass-card-guide">
                    <FormattedMessage
                      id="app.dashcard.paid"
                      defaultMessage="Maksupäivä"
                    />
                  </p>
                  <p className="ass-card-price">{this.props.paid} </p>
                </div>
              ) : null}

              <div className="col-md-2">
                <p className="ass-card-guide">
                  <FormattedMessage
                    id="app.dashcard.case_status"
                    defaultMessage="Asian tila"
                  />
                </p>
                <p className="ass-card-price">{this.props.status} </p>
                <hr className={"d-block d-sm-block d-md-none"} />
              </div>

              <div className="col-md-6 text-right">
                {this.props.buttons.map(btn => (
                  <Button
                    key={btn.btnKey}
                    btnText={btn.btnText}
                    btnStyle={btn.btnStyle}
                    btnPath={btn.btnPath}
                    payNow={btn.payNow}
                    btnId={btn.btnId}
                  />
                ))}
                {this.props.payBtn ? (
                    <button className={"btn btn-primary"} onClick={()=>{this.props.history.push(`/checkout?customer_id=${this.props.user.id}&order_number=${this.props.paymentForm.ORDER_NUMBER}&amount=${this.props.paymentForm.AMOUNT}`)}}>
                      {this.props.payBtn}
                    </button>
                ) : null}
                {this.props.pdfBtn ? (
                  <button className={`btn btn-${this.props.pdfBtn.btnStyle}`}>
                    {this.props.pdfBtn.btnText}
                  </button>
                ) : null}
              </div>
            </div>
            <div className={"row"}>
              <div className={"col-12 text-right"}>
                {this.props.bills ? (
                  <div
                    className={"btn"}
                    onClick={() =>
                      this.setState({ expanded: !this.state.expanded })
                    }
                  >
                    <FormattedMessage
                      id="app.dashcard.sent_bills"
                      defaultMessage="Lähetetyt asiakirjat"
                    />{" "}
                    <FontAwesomeIcon
                      icon="angle-down"
                      size="lg"
                      className={"fa-fw"}
                    />
                  </div>
                ) : null}
                {/* expandable element START */}
                {this.state.expanded ? (
                  <div className="row row-expandable justify-content-end">
                    {this.props.bills
                      ? this.props.bills.map((bill, index) => (
                          <div className="col-12 bill">
                            <a
                              key={`pdfbtn-${index}`}
                              id={`pdfbtn-${index}`}
                              href={`${process.env.REACT_APP_FILE_URL}${bill.tiedostolinkki}`}
                            >
                              {bill.nimi}{" "}
                              <FontAwesomeIcon
                                icon="file-pdf"
                                size="1x"
                                className={"fa-fw"}
                              />
                            </a>
                          </div>
                        ))
                      : null}
                  </div>
                ) : null}
                {/* expandable element END */}
              </div>
            </div>
          </div>
        </div>
      </li>
    );
  }
}

const mapStateToProps = function(store) {
  return {
    user: store.user.user
  };
};
export default withRouter(connect(mapStateToProps, null)(DashCard));



// WEBPACK FOOTER //
// ./src/components/DashCard.js